import { GraphNode } from '../graph-node.js';
import { describeNodeData, traceGraph, traceGraphWarning } from '../debug.js';
import { reportGraphError } from '../errors.js';
export class ActionNode extends GraphNode {
    implementationFunction;
    constructor(id, data, type, implementationFunction = null) {
        super(id, data, type);
        this.implementationFunction = implementationFunction;
    }
    async run() {
        super.run();
        traceGraph(`action ${this.type} (${this.id}) start`, {
            hasImplementation: !!this.implementationFunction,
            data: describeNodeData(this.data),
        });
        if (!this.implementationFunction) {
            traceGraphWarning(`action ${this.type} (${this.id}) has NO implementation - node does nothing`);
        }
        const promise = this.runImplementation();
        this.waitForOnFinished(promise);
        this.triggerOutPort('exec');
    }
    /**
     * Errors must not escape as an unhandled rejection: that would stop the exec
     * chain at this node with no diagnostic (`onFinished` would never fire).
     */
    async waitForOnFinished(promise) {
        if (!promise)
            return;
        try {
            await promise;
        }
        catch (error) {
            reportGraphError({
                kind: 'action',
                nodeType: this.type,
                nodeId: this.id,
                summary: 'failed - everything wired to "onFinished" is skipped',
                error,
            });
            return;
        }
        traceGraph(`action ${this.type} (${this.id}) finished`);
        this.triggerOutPort('onFinished');
    }
    async runImplementation() {
        if (!this.implementationFunction)
            return;
        await this.implementationFunction(this.data, this.id);
    }
}
